// ハンバーガーメニュー
const trigger = document.getElementById('menu-trigger');
const overlay = document.getElementById('menu-overlay');
const body = document.body;
trigger.addEventListener('click', () => {
    body.classList.toggle('menu-open');
});
overlay.addEventListener('click', () => {
    body.classList.remove('menu-open');
});

